export default __webpack_public_path__ + "static/media/default_user_placeholder.9de96049.svg";